import { html } from 'htm/preact';
import { useState, useRef, useEffect, useContext } from 'preact/hooks';
import { Textfield } from "../../../bpmn.io/@bpmn-io/form-js-viewer";
import {  Errors, FormContext, Numberfield, Description, Label } from '../../../bpmn.io/@bpmn-io/form-js';
import classNames from "../../../bpmn.io/classnames";
import { AppData } from "../../helpers/app-data";

export const type = "dataSelectorButton";

// Componente principal DataSelector
export function DataSelector(props) {

  const {
    placeholder = 'Seleccione un elemento...',
    readonly,
    field,
    value = '',
    disabled,
    errors = [],
    valueField = 'nombre',
  } = props;


  const {
    description,
    id,
    label,
    validate = {},
    properties
  } = field;

  const prefixId = `fjs-form-${id}`;
  const { required } = validate;
  const { formId } = useContext(FormContext);

  // Estado para controlar la visibilidad del div
  const [isVisible, setIsVisible] = useState(false);
  //const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fabricLoaded, setFabricLoaded] = useState(false);
  const [dataTableInitialized, setDataTableInitialized] = useState(false);

  var internalvariables = [];
  var aditionalFlowData = [];

  function updateInternalData(data) {
    
    window.interalData = data;
    if (window.onInternalDataUpdate) {
      window.onInternalDataUpdate(data);
    }
  }

  // Asignar la función al objeto interno window para que pueda ser accedida internamente
  window.updateInternalData = updateInternalData;

  function updateAditionalFlowData(data) {
    window.aditionalFlowData = data;
    if (window.onAditionalFlowDataUpdate) {
      window.onAditionalFlowDataUpdate(data);
    }
  }

  // Asignar la función al objeto global window para que pueda ser accedida globalmente
  window.updateAditionalFlowData = updateAditionalFlowData;

  function filtrarColumnPropiedades(obj) {
    const resultado = [];
    
    // Recorrer todas las propiedades del objeto
    for (const key in obj) {
      // Verificar si la propiedad comienza con "column."
      if (key.startsWith("column.")) {
        // Extraer la palabra después del prefijo "column."
        const title = key.substring("column.".length);
        
        // Añadir al resultado con el formato requerido
        resultado.push({
          title: title,
          data: obj[key]
        });
      }
    }
    
    return resultado;
  }

  function filtrarParameterPropiedades(obj) {
    var resultado = "";
    
    // Recorrer todas las propiedades del objeto
    for (const key in obj) {
      // Verificar si la propiedad comienza con "column."
      if (key.startsWith("parameter.")) {
        // Extraer la palabra después del prefijo "column."
        const param = key.substring("parameter.".length);
        
        if(resultado == "")
        {
          resultado = "?" + param + "=" + GetValueVariable(obj[key]);
        }
        else
        {
          resultado += "&" + param + "=" + GetValueVariable(obj[key]);
        }
        
      }
    }
    
    return resultado;
  }

  function filtrarInternalVariablesPropiedades(obj) {
    const resultado = [];
    
    // Recorrer todas las propiedades del objeto
    for (const key in obj) {
      // Verificar si la propiedad comienza con "column."
      if (key.startsWith("internal.")) {
        // Extraer la palabra después del prefijo "column."
        const title = key.substring("internal.".length);
        
        // Añadir al resultado con el formato requerido
        resultado.push({
          variable: title,
          columna: obj[key]
        });
      }
    }
    
    return resultado;
  }

  function filtrarAditionalFlowDataPropiedades(obj) {
    const resultado = [];
    
    // Recorrer todas las propiedades del objeto
    for (const key in obj) {
      // Verificar si la propiedad comienza con "column."
      if (key.startsWith("flujo.")) {
        // Extraer la palabra después del prefijo "column."
        const title = key.substring("flujo.".length);
        
        // Añadir al resultado con el formato requerido
        resultado.push({
          variable: title,
          columna: obj[key]
        });
      }
    }
    
    return resultado;
  }

  function GetValueVariable(data)
  {
    var result = "null";

    if(data.startsWith("flujo."))
    {
      result = props.fieldInstance.expressionContextInfo.data.flujo[data.split('.')[1]];
    }
    else if (data.startsWith("internal."))
    {
      result = window.interalData[data.split('.')[1]];
    }
    else
    {
      result = data;
    }

    return result;
  }

  // Función para inicializar la DataTable
    const initializeDataTable = () => {
      const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
  
      if (typeof $ !== 'undefined' && $.fn.DataTable && !dataTableInitialized) {
        const tableId = `${prefixId}-datatable`;
        const tableElement = document.getElementById(tableId);
        
        if (tableElement) {
          try {
            if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
              $(`#${tableId}`).DataTable().destroy();
            }

            setIsLoading(true);
            
            // Obtener el nuevo array de objetos
            const columnItems = filtrarColumnPropiedades(properties);
            const paramItems = filtrarParameterPropiedades(properties);
            internalvariables = filtrarInternalVariablesPropiedades(properties);
            aditionalFlowData = filtrarAditionalFlowDataPropiedades(properties);
    
            // const dataTableInstance = $(`#${tableId}`).DataTable({
            //   pagingType: 'full_numbers',
            //   pageLength: 5,
            //   processing: true,
            //   serverSide: false, 
            //   ajax: {
            //     url: AppData.API_URL + properties["endpoint.url"]+'?columnrender=' + properties["columrender"], //'Usuario/GetDataTableUsuario', 
            //     type: 'POST',
            //     contentType: 'application/json',
            //     beforeSend: function (xhr) {
            //       xhr.setRequestHeader('X-APIKey', AppData.API_KEY); 
            //       xhr.setRequestHeader('Authorization', 'Bearer ' + API_TOKEN);
  
            //     },
            //     data: function(d) {
            //       return JSON.stringify(d);
            //     },              
            //     dataSrc: function(json) {
            //       json.recordsTotal = json.Data.recordsTotal;
            //       json.recordsFiltered = json.Data.recordsFiltered;
            //       json.draw = json.Data.draw;
            //       return json.Data.data; 
            //   }
            //   },
            //   columns: [ ...columnItems,
            //       // { title: "Email", data: "Email" },
            //       // { title: "Usuario", data: "NombreUsuario" },
            //       // { title: "Rol", data: "NombreRol", orderable: false },
            //       // { title: "Identificacion", data: "Identificacion" },
            //       {
            //       title: 'Acciones',
            //       data: properties["columnpersist"],
            //       orderable: false,
            //       render: function(data, type, full) {
            //         return `<button class="ms-CommandButton-button" data-group="usuario" data-id="${full[properties["columnpersist"]]}" data-field="${full[properties["columrender"]]}" id="btnSelect-${full[properties["columnpersist"]]}" type="button">
            //           <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i title="Seleccionar" class="ms-Icon ms-Icon--Bullseye"></i></span>
            //         </button>`;
            //       }
            //     }
            //   ],
            //   language: {
            //     url: '../../../assets/es-ES.json'},
            //   lengthMenu: [5]
            // });

            let tabla = $(`#${tableId}`).DataTable({
              // Configuración de paginación
              paging: true,
              pageLength: 5,         // Registros por página
              lengthMenu: [5], // Opciones de registros por página
              
              // Configuración de ordenamiento
              ordering: true,
              
              // Configuración de búsqueda
              searching: true,
              
              // Configuración para el procesamiento
              processing: true,
              
              // Configurar datos vacíos inicialmente
              data: [],
              
              // Idioma (opcional)
              language: {
                     url: '../../../assets/es-ES.json'},
              
              // Definir las columnas (ajusta según tu estructura de datos)
              columns: [ ...columnItems,
                      // { title: "Email", data: "Email" },
                      // { title: "Usuario", data: "NombreUsuario" },
                      // { title: "Rol", data: "NombreRol", orderable: false },
                      // { title: "Identificacion", data: "Identificacion" },
                      {
                      title: 'Acciones',
                      data: properties["columnpersist"],
                      orderable: false,
                      render: function(data, type, full) {

                        const fullObjectEncoded = encodeURIComponent(JSON.stringify(full));

                        return `<button class="ms-CommandButton-button" data-object="${fullObjectEncoded}" data-id="${full[properties["columnpersist"]]}" data-field="${full[properties["columnrender"]]}" id="btnSelect-${full[properties["columnpersist"]]}" type="button">
                          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i title="Seleccionar" class="ms-Icon ms-Icon--Bullseye"></i></span>
                        </button>`;
                      }
                    }
                  ]
            });

            $.ajax({
              url: AppData.API_URL + properties["endpoint.url"] + (paramItems != "" ? paramItems : ""),
              type: 'POST',
              dataType: 'json',
              beforeSend: function (xhr) {
                      xhr.setRequestHeader('X-APIKey', AppData.API_KEY); 
                      xhr.setRequestHeader('Authorization', 'Bearer ' + API_TOKEN);
      
                    },
              success: function(response) {
                // Cargar los datos en la tabla y actualizar
                
                setIsLoading(false);
                tabla.clear();
                tabla.rows.add(response.Data.data);
                tabla.draw();
              },
              error: function(error) {
                
                console.error('Error al cargar los datos:', error);
              }
            });
    
            // Agregar manejadores de eventos
            $(`#${tableId}`).on('click', '[id^=btnSelect-]', function() {
              
              const id = $(this).data('id');
              const render = $(this).data('field');
              const row = JSON.parse(decodeURIComponent($(this).data('object')));

              handleRowSelect(render, id, row);
              closeModal();
            });
    
            setDataTableInitialized(true);
          } catch (error) {
            console.error("Error al inicializar DataTable:", error);
          }
        }
      }
    };
    
  
    // Función para abrir el modal
    const openModal = () => {
      setIsModalOpen(true);
      // Inicializamos el diálogo tras abrir
      setTimeout(() => {
        initializeFabricDialog();
        
        // Inicializar DataTable después de que el diálogo esté abierto
        setTimeout(() => {
          initializeDataTable();
        }, 100);
      }, 10);
    };
  
    // Función para cerrar el modal
    const closeModal = () => {
      setIsModalOpen(false);
      if (window.fabricDialogs && window.fabricDialogs[prefixId]) {
        window.fabricDialogs[prefixId].close();
        // Eliminamos la referencia al diálogo para poder recrearlo después
        delete window.fabricDialogs[prefixId];
      }
      setDataTableInitialized(false);
    };
  
    // Inicializar el diálogo de Fabric UI
    const initializeFabricDialog = () => {
      if (typeof fabric !== 'undefined' && fabric.Dialog) {
        const dialogElement = document.getElementById(`${prefixId}-dialog`);
        
        if (dialogElement) {
          // Inicializamos el objeto contenedor si no existe
          if (!window.fabricDialogs) {
            window.fabricDialogs = {};
          }
          
          // Creamos un nuevo diálogo
          if (!window.fabricDialogs[prefixId]) {
            window.fabricDialogs[prefixId] = new fabric.Dialog(dialogElement);
            
            dialogElement.addEventListener('click', (e) => {
              e.stopPropagation(); // Evitar que el clic se propague al fondo
            });

            // Manejar el cierre del diálogo
            const closeButton = dialogElement.querySelector('.ms-Dialog-buttonClose');
            if (closeButton) {
              closeButton.addEventListener('click', closeModal);
            }
          }
          
          window.fabricDialogs[prefixId].open();
        }
      }
    };

    useEffect(() => {
      if (isModalOpen) {
        // Bloquear el cierre al hacer clic en el overlay
        const handleClickOutside = (e) => {
          const dialogElement = document.getElementById(`${prefixId}-dialog`);
          if (dialogElement && !dialogElement.contains(e.target)) {
            e.stopPropagation();
            e.preventDefault();
          }
        };
   
        document.addEventListener('click', handleClickOutside, true); // Captura en fase de captura
        return () => {
          document.removeEventListener('click', handleClickOutside, true);
        };
      }
    }, [isModalOpen]);
  
    const tableContent = html`
    <div class="datatable-container" style="width: 100%; overflow-x: auto;">  
      <table id="${prefixId}-datatable" class="ms-Table ms-Table--selectable order-column row-border" style="width: 100%;">
        <thead>
          <tr>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>
  `;


  var visible = true;
    // Función para alternar la visibilidad
  const toggleVisibility = () => {
    if(visible)
    {
      $('#divContent').show();
      visible = false;
      
    }
    else
    {
      $('#divContent').hide();
      visible = true;
    }
    setIsVisible(!isVisible);
    
  };
  
  
  // Actualizar el valor del textbox cuando se selecciona un elemento
  useEffect(() => {
    if (selectedItem) {
      
      setSelectedValue(selectedItem || '');
    }
  }, [selectedItem, valueField]);

  // Función para manejar cambios en el input
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  
  // Abrir modal
  // const handleOpenModal = () => {
  //   
  //   setIsModalOpen(true);
  // };
  
  // Cerrar modal
  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  // };
  
  // Manejar selección en la tabla
  const handleRowSelect = (item, id, row) => {
    
    setSelectedItem(item);
    
    props.onChange({
      field,
      value: id
    });

    var internalObj = window.interalData ? window.interalData : [];

    for (const variable in internalvariables) {

      var varname = internalvariables[variable]["variable"];      
      internalObj[varname] = row[internalvariables[variable]["columna"]];
    
    }

    updateInternalData(internalObj);

    var globalObj = window.aditionalFlowData ? window.aditionalFlowData : [];

    for (const variable in aditionalFlowData) {

      var varname = aditionalFlowData[variable]["variable"];      
      globalObj[varname] = row[aditionalFlowData[variable]["columna"]];
    
    }

    updateAditionalFlowData(globalObj);

  };

  return html`<div className="data-selector" class=${editorFormFieldClasses("modal", { disabled })}>
      <${Label} id=${prefixId} label=${label} required=${required} />
      <div className="input-group">
        <button 
          id=${prefixId}-button
          className="selector-button" 
          type="button"
          onClick=${openModal}
          title=${label}
        >
          <span className="search-icon">🔍</span>
        </button>
        <input 
          type="text" 
          className="selector-input"
          value=${selectedValue}
          placeholder=${placeholder}
          readOnly
        />
      </div>

      ${isModalOpen && html`
        <div id=${prefixId}-dialog class="ms-Dialog ms-Dialog--lgHeader">
          <div class="ms-Dialog-title">
            <span>${label || 'Seleccione un item'}</span>
          </div>
          <div class="ms-Dialog-content" style="width: 800px; max-width: 90vw;">
            ${isLoading && html`<div class="loading-overlay">
              <div class="spinner">
                <div class="spinner-text">Obteniendo datos...</div>
              </div>
            </div>`}
            ${tableContent}
          </div>
          <div class="ms-Dialog-actions">
            <button 
              class="ms-Button ms-Button--primary claseForm" 
              onClick=${closeModal}
              type="button"
            >
              <span class="ms-Button-label">Cerrar</span>
            </button>
          </div>
        </div>
      `}  
            
      <style jsx>
        .data-selector {
          margin-bottom: 1rem;
          padding-left: 5px;
        }
        
        .div-test {
            padding: 15px;
            background: #f5f5f5;
            border: 1px solid #ddd;
            borderRadius: 4px;
          }
        
        .input-group {
          display: flex;
          align-items: center;
          flex-direction: row !important;
          margin-top: 1%;
        }
        
        .selector-button {
          padding: 0.5rem;
          background: #4a90e2;
          color: white;
          border: none;
          border-radius: 4px 0 0 4px;
          cursor: pointer;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .search-icon {
          font-size: 16px;
        }
        
        .selector-input {
          flex-grow: 1;
          padding: 0.5rem;
          border: 1px solid #ccc;
          border-left: none;
          border-radius: 0 4px 4px 0;
          height: 38px;
          background-color: #f9f9f9;
        }
        
        .modal-tables-container {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .spinner {
          text-align: center;
        }

        .spinner-text {
          margin-top: 10px;
          font-weight: bold;
        }
      </style>
    </div>`
  ;
  
}

// FabricModalRenderer.config = {
//   ...Button.config,
//   type: type,
//   label: "Modal de Fabric UI con DataTable",
//   iconUrl: "",
//   propertiesPanelEntries: ["label", "modalTitle"],
//   // Define los campos adicionales para el panel de propiedades
//   additionalProperties: [
//     {
//       id: "modalTitle",
//       label: "Título del Modal",
//       type: "String",
//       defaultValue: "Gestión de Usuarios"
//     }
//   ]
// };

export function editorFormFieldClasses(type, { disabled = false } = {}) {
  if (!type) {
    throw new Error("type required");
  }

  return classNames("fjs-form-field", `fjs-form-field-${type}`, {
    "fjs-disabled": disabled,
  });
}

function prefixId(id, formId) {
  if (formId) {
    return `fjs-form-${formId}-${id}`;
  }

  return `fjs-form-${id}`;
}

DataSelector.config = {
  ...Textfield.config,
  type: type,
  label: "Selector de datos",
  iconUrl: ``,
  propertiesPanelEntries: ["label"],
};
